import type {ReactNode} from 'react';
import React from 'react';
import type {ItemAiEditChatPanelProps} from './item-ai-edit-chat-panel.types';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {ImageItem} from '@PosterWhiteboard/items/image-item/image-item.class';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import {IneditorChatPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/ineditor-chat-panel/ineditor-chat-panel';
import {useGetKeyFromImageItem} from '@Hooks/poster-editor/useGetKeyFromImageItem';
import {AiChatProvider} from '@/ai-chat/providers/ai-chat-provider';
import {useGetTeamCredits} from '@Hooks/useGetTeamCredits';

export function ItemAiEditChatPanel({...props}: ItemAiEditChatPanelProps): ReactNode {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? (window.posterEditor?.whiteboard?.getItemForId(activeItemId) as ImageItem) : undefined;
  const aiChatId = useGetKeyFromImageItem('aiChatId');
  const credits = useGetTeamCredits() ?? 0;

  if (!activeItem) {
    return null;
  }

  const itemType = activeItem.gitype;

  if (!(itemType === ITEM_TYPE.IMAGE || itemType === ITEM_TYPE.IMAGEBACKGROUND || itemType === ITEM_TYPE.IMAGESLIDE)) {
    return null;
  }

  const onChatIdChange = (newChatId: string | undefined): void => {
    void activeItem.updateFromObject(
      {
        aiChatId: newChatId,
      },
      {undoable: false, updateRedux: true}
    );
  };

  // In-editor AI chat is only available to premium users within the poster editor, so PAYG access is always false here.
  return (
    <AiChatProvider credits={credits} isPaygUserWithAiChatAccess={false} isReturningUser={false} isSuperUser={false}>
      <IneditorChatPanel chatId={aiChatId} posterHashedId={activeItem.page.poster.hashedID} graphicItemUid={activeItem.uid} onChatIdChange={onChatIdChange} />
    </AiChatProvider>
  );
}
